export default function Hero() {
  const scrollToProducts = () => {
    const element = document.getElementById('productos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Lazy Loading */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/54674cd3e9ee800362d57411781de5ae.jpg"
          alt="LELO Premium Experience"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 py-20 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="https://public.readdy.ai/ai/img_res/1e91301a-5055-4420-88b8-44ebb4ebd982.png"
            alt="Conejox Logo"
            className="h-12 sm:h-16 w-auto"
          />
        </div>

        {/* Headline */}
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight px-2">
          Descubre lo mejor de LELO:<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-300 to-fuchsia-200">
            lujo, tecnología y placer
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-10 max-w-3xl mx-auto font-light px-4">
          Compara los 6 juguetes sexuales más populares de LELO y elige el tuyo
        </p>

        {/* CTA Button */}
        <a
          href="https://amzn.to/4pHWB8J"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="whitespace-nowrap inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-fuchsia-500 to-pink-500 hover:from-fuchsia-600 hover:to-pink-600 text-white px-6 sm:px-8 md:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-semibold transition-all duration-300 shadow-2xl hover:shadow-fuchsia-500/50 hover:scale-105 cursor-pointer"
        >
          <span>Ver ofertas en Amazon</span>
          <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
        </a>

        {/* Trust Indicators */}
        <div className="mt-12 sm:mt-16 flex flex-col sm:flex-row flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 text-white/80 px-4">
          <div className="flex items-center justify-center gap-2">
            <i className="ri-award-line text-xl sm:text-2xl text-yellow-400"></i>
            <span className="text-xs sm:text-sm">Premiado internacionalmente</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <i className="ri-shield-check-line text-xl sm:text-2xl text-green-400"></i>
            <span className="text-xs sm:text-sm">Silicona de grado médico</span>
          </div>
          <div className="flex items-center justify-center gap-2">
            <i className="ri-star-line text-xl sm:text-2xl text-yellow-400"></i>
            <span className="text-xs sm:text-sm">Diseño sueco premium</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/80"></i>
      </div>
    </section>
  );
}
